import { makeStyles } from '@material-ui/core/styles';
import { buttonAddStyles, buttonDeleteStyles } from 'shared/Buttons/button.styles';

export const useViewArticlesStyles = makeStyles(theme => ({
  modal: {
    '& .MuiDialog-paperFullWidth': {
      minWidth: '40rem'
    }
  },
  buttonAdd: {
    ...buttonAddStyles
  },
  buttonDelete: {
    ...buttonDeleteStyles
  }
}));
